import client from "./client";

export default {
    async login(credentials) {
        return client.parseResponse(await client.post('/login', credentials))
    },
    async getProfile(filters) {
        return client.parseResponse(await client.get('/profile', filters))
    },
    async logout(filters) {
        return client.parseResponse(await client.post('/logout', filters))
    },
    async verify2FA(data) {
        return client.parseResponse(await client.post('/verify-2fa-login', data))
    },
    async validateGoogleLogin(credentials) {
        return client.parseResponse(await client.post('/validate-google-login', credentials))
    },
    async sendResetPasswordLink(credentials) {
        return client.parseResponse(await client.post('/reset', credentials));
    },

    // Unauthenticated on purpose - see Auth\RegisterController@verifyEmail.
    async verifyEmail(token) {
        return client.parseResponse(await client.post(`/verify-email/${token}`));
    },

    async resendEmailVerification() {
        return client.parseResponse(await client.post('/resend-email-verification'));
    },

    async createUser(data) {
        return client.parseResponse(await client.post('/users', data));
    },
    async editUser(data) {
        return client.parseResponse(await client.put('/users/' + data.id, data));
    },
    async getUsers(filters) {
        return client.parseResponse(await client.get('/users', filters));
    },

    async getUser(id) {
        return client.parseResponse(await client.get('/users/' + id));
    },

    async getActivitySummary() {
        return client.parseResponse(await client.get('/activity-summary/'));
    },

    async getRouteFrequenciesUser(filters) {
        return client.parseResponse(await client.get('/user-route-frequencies', filters));
    },
    async deleteFrequencyUser(id) {
        return client.parseResponse(await client.delete('/user-route-frequencies/' + id));
    },
    async getUserModules(filters) {
        return client.parseResponse(await client.get('/user-modules', filters));
    },
    async syncUserSuppliers(filters) {
        return client.parseResponse(await client.post('/user-suppliers', filters));
    },
    async syncUserTeams(filters) {
        return client.parseResponse(await client.post('/user-teams', filters));
    },
    async syncUserCompanies(filters) {
        return client.parseResponse(await client.post('/user-companies', filters));
    },
    async syncUserModules(data) {
        return client.parseResponse(await client.post('/user-modules', data));
    },
    async getUserRegions(filters) {
        return client.parseResponse(await client.get('/user-regions', filters));
    },
    async getUserTeams(filters) {
        return client.parseResponse(await client.get('/user-teams', filters));
    },
    async getUserCompanies(filters) {
        return client.parseResponse(await client.get('/user-companies', filters));
    },
    async getUserSuppliers(filters) {
        return client.parseResponse(await client.get('/user-suppliers', filters));
    },
    async getSupervisors(filters) {
        return client.parseResponse(await client.get('/supervisors', filters));
    },
    async getUserProductSkus(filters) {
        return client.parseResponse(await client.get('/user-product-skus-web', filters));
    },
    async getUserCategories(filters) {
        return client.parseResponse(await client.get('/user-categories', filters));
    },
    async syncUserRegions(data) {
        return client.parseResponse(await client.post('/user-regions', data));
    },
    async syncUserProductSkus(data) {
        return client.parseResponse(await client.post('/user-product-skus', data));
    },
    async syncUserCategories(data) {
        return client.parseResponse(await client.post('/user-categories', data));
    },
    async uploadUsers(filters) {
        return client.parseResponse(await client.upload('/users-import', {file: filters}));
    },

    async getUserActivityLogs(filters) {
        return client.parseResponse(await client.get('/user-activity-logs', filters));
    },

}
